export default __webpack_public_path__ + "static/media/courses-grey.543dca12.svg";